(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["preorder-scroll"] && !Shopify.designMode) return;
  try {
    
var section = document.querySelector('.preorder-scroll-section');
if (section) {
  var overlay = section.querySelector('.overlay');
  var content = section.querySelector('.content-wrapper');

  if (!Shopify.designMode) {
    if (content) content.style.opacity = 0;
    // overlay already 0

    function handleScroll() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / rect.height));
      overlay.style.opacity = progress;
      content.style.opacity = progress;
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    document.addEventListener('DOMContentLoaded', handleScroll);
    handleScroll(); // Initial call
  } else {
    // In design mode, force end state for preview
    overlay.style.opacity = 1;
    content.style.opacity = 1;
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-auction"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-two-columns"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  // Function to handle visibility based on screen size
  function handleResponsiveCollapse() {
    if (window.matchMedia('(max-width: 40em)').matches) {
      // Mobile view
      $('.rich-text__body_mobile').hide();
      $('.rich-text__collapse').each(function() {
        var $iconPlus = $(this).find('svg').eq(0); // First SVG (plus icon)
        var $iconMinus = $(this).find('svg').eq(1); // Second SVG (minus icon)
        $iconPlus.show();
        $iconMinus.hide();
      });

      // Toggle .rich-text__body_mobile and icons on click
      $('.rich-text__collapse').off('click').on('click', function() {
        var $body = $(this).next('.rich-text__body_mobile');
        $body.toggle();
        
        var $iconPlus = $(this).find('svg').eq(0); // First SVG (plus icon)
        var $iconMinus = $(this).find('svg').eq(1); // Second SVG (minus icon)
        
        if ($body.is(':visible')) {
          $iconPlus.hide();
          $iconMinus.show();
        } else {
          $iconPlus.show();
          $iconMinus.hide();
        }
      });
    } else {
      // Desktop view
      $('.rich-text__body_mobile').show();
      $('.rich-text__collapse').each(function() {
        var $iconPlus = $(this).find('svg').eq(0); // First SVG (plus icon)
        var $iconMinus = $(this).find('svg').eq(1); // Second SVG (minus icon)
        $iconPlus.hide();
        $iconMinus.hide();
      });

      // Remove click events for desktop view
      $('.rich-text__collapse').off('click');
    }
  }

  // Initial check
  handleResponsiveCollapse();

  // Recheck on window resize
  $(window).resize(function() {
    handleResponsiveCollapse();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow--dynamic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aoj-slideshow')) {
    class AojSlideshow extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.aoj-ss') || this;
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.layers = Array.from(this.querySelectorAll('[data-parallax-layer]'));
        this.delay = (parseFloat(this.dataset.autoplay) || 0) * 1000;
        this.speed = parseFloat(this.dataset.speed) || 800;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.holds = new Set(['offscreen']);
        this.cleanups = [];

        this.bindControls();
        this.bindPauses();
        this.bindEditor();
        this.setupParallax();

        this.root.classList.add('js-ready');
        this.goTo(this.index, { instant: true });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.leaveTimer);
        this.cleanups.forEach((fn) => fn());
        this.cleanups = [];
      }

      listen(target, type, fn, options) {
        target.addEventListener(type, fn, options);
        this.cleanups.push(() => target.removeEventListener(type, fn, options));
      }

      /* ---------- Controls ---------- */
      bindControls() {
        this.listen(this, 'click', (event) => {
          const t = event.target;
          if (t.closest('[data-prev]')) return this.goTo(this.index - 1);
          if (t.closest('[data-next]')) return this.goTo(this.index + 1);

          const dot = t.closest('[data-dot]');
          if (dot) return this.goTo(parseInt(dot.dataset.dot, 10));

          const opener = t.closest('[data-popup-open]');
          if (opener) return this.openPopup(opener.dataset.popupOpen);

          const closer = t.closest('[data-popup-close]');
          if (closer) return closer.closest('dialog')?.close();

          if (t instanceof HTMLDialogElement) t.close(); // click on the dark backdrop
        });

        this.listen(this, 'keydown', (event) => {
          if (event.target.closest('dialog')) return;
          if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
          if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        });

        if (this.track && this.slides.length > 1) {
          let startX = null;
          let startY = null;
          this.listen(this.track, 'touchstart', (event) => {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          }, { passive: true });
          this.listen(this.track, 'touchend', (event) => {
            if (startX === null) return;
            const touch = event.changedTouches[0];
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;
            startX = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this.goTo(this.index + (dx < 0 ? 1 : -1));
            }
          }, { passive: true });
        }
      }

      openPopup(id) {
        const dialog = document.getElementById(id);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        dialog.showModal();
        this.hold('popup');
        dialog.addEventListener('close', () => this.release('popup'), { once: true });
      }

      /* ---------- Autoplay pausing ---------- */
      bindPauses() {
        if (this.dataset.pauseHover === 'true') {
          this.listen(this, 'mouseenter', () => this.hold('hover'));
          this.listen(this, 'mouseleave', () => this.release('hover'));
        }
        this.listen(this, 'focusin', () => this.hold('focus'));
        this.listen(this, 'focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.release('focus');
        });
        this.listen(document, 'visibilitychange', () => {
          document.hidden ? this.hold('tab') : this.release('tab');
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
              this.root.classList.add('is-inview');
              this.release('offscreen');
            } else {
              this.hold('offscreen');
            }
          }, { threshold: 0.25 });
          observer.observe(this);
          this.cleanups.push(() => observer.disconnect());
        } else {
          this.root.classList.add('is-inview');
          this.holds.delete('offscreen');
        }
      }

      /* ---------- Theme editor ---------- */
      bindEditor() {
        this.listen(document, 'shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i === -1) return;
          this.hold('editor');
          this.goTo(i, { instant: true });
        });
        this.listen(document, 'shopify:block:deselect', (event) => {
          if (this.slides.includes(event.target)) this.release('editor');
        });
      }

      /* ---------- Slide change ---------- */
      goTo(target, { instant = false } = {}) {
        const count = this.slides.length;
        if (!count) return;
        const next = ((target % count) + count) % count;
        const prev = this.slides[this.index];

        if (prev && next !== this.index && !instant && !this.reduceMotion) {
          clearTimeout(this.leaveTimer);
          this.slides.forEach((slide) => slide.classList.remove('is-leaving'));
          prev.classList.add('is-leaving');
          this.leaveTimer = setTimeout(() => prev.classList.remove('is-leaving'), this.speed);
        }

        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
          slide.querySelectorAll('video').forEach((video) => {
            if (active) {
              const playing = video.play();
              if (playing && playing.catch) playing.catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
        this.index = next;
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.delay || this.slides.length < 2 || this.holds.size) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1), this.delay);
      }

      hold(reason) {
        this.holds.add(reason);
        clearTimeout(this.timer);
      }

      release(reason) {
        this.holds.delete(reason);
        this.schedule();
      }

      /* ---------- Parallax ---------- */
      setupParallax() {
        if (this.dataset.parallax !== 'true' || this.reduceMotion || !this.layers.length) return;
        const strength = (parseFloat(this.dataset.parallaxStrength) || 15) / 100;
        const allowMobile = this.dataset.parallaxMobile === 'true';
        const mobile = window.matchMedia('(max-width: 749px)');
        let ticking = false;

        const update = () => {
          ticking = false;
          if (mobile.matches && !allowMobile) return;
          const rect = this.getBoundingClientRect();
          const vh = window.innerHeight;
          if (rect.bottom < 0 || rect.top > vh) return;
          const progress = (vh - rect.top) / (vh + rect.height);
          const y = (progress - 0.5) * 2 * strength * rect.height;
          this.layers.forEach((layer) => {
            layer.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0)`;
          });
        };
        const request = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        };

        this.listen(window, 'scroll', request, { passive: true });
        this.listen(window, 'resize', request);
        update();
      }
    }

    customElements.define('aoj-slideshow', AojSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
